import { render, staticRenderFns } from "./SurfaceLayer.vue?vue&type=template&id=320b7965&scoped=true&lang=pug"
import script from "./SurfaceLayer.vue?vue&type=script&lang=ts"
export * from "./SurfaceLayer.vue?vue&type=script&lang=ts"
import style0 from "./SurfaceLayer.vue?vue&type=style&index=0&id=320b7965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "320b7965",
  null
  
)

/* custom blocks */
import block0 from "./SurfaceLayer.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports